var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleLeftGray = function SvgAngleLeftGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    viewBox: "0 0 7.554 13.125"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".AngleLeftGray{fill:#80868B;opacity:1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "AngleLeftGray",
    d: "M15.407,11.183,9.849,5.635A.983.983,0,0,0,8.455,7.019l4.861,4.91L8.455,16.79a.983.983,0,1,0,1.394,1.385l5.558-5.548a.982.982,0,0,0,0-1.444Z",
    transform: "translate(-8.169 -5.344)"
  })));
};
export default SvgAngleLeftGray;